import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuthStore } from './authStore.js';

/**
 * Gate for routes that need a signed-in user.
 *
 * While the stored token is being validated the status is `loading`, and this
 * renders a placeholder rather than redirecting - otherwise every refresh would
 * bounce an authenticated user through the login screen before snapping back.
 *
 * The attempted location is passed along so login can return the user where they
 * were heading.
 */
export function RequireAuth() {
  const status = useAuthStore((state) => state.status);
  const location = useLocation();

  if (status === 'loading') {
    return <div className="centered muted">Checking your session…</div>;
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
